import { getAppointmentTime } from "../../../../utils/formatData";
import getTime from "../../../../utils/getTimePeriod";
import { logEvent } from "../../../../utils/Analytics";
import { LPEFeedbackWrapper } from "../../../../utils/common";

export const getLoadStopDetails = (props: any) => {
  let loadStop = [];
  let sortedLoadStops =
    props.loadStop?.slice()?.sort((load1: any, load2: any) => {
      if (load1.sequenceNo && load2.sequenceNo) {
        return load1.sequenceNo - load2.sequenceNo;
      }
      if (load1.stopSequence && load2.stopSequence) {
        return load1.stopSequence - load2.stopSequence;
      }
      return 0;
    }) || [];

  if (!props.isCarrierLoad) {
    sortedLoadStops = sortedLoadStops.filter((stop: any) => {
      return stop.stopType !== "NFR";
    });
  }

  loadStop[0] = sortedLoadStops && sortedLoadStops[0];
  loadStop[1] = sortedLoadStops && sortedLoadStops[sortedLoadStops.length - 1];
  return loadStop;
};
export const calculateTime = (stop: any, myload = false) => {
  if (myload) {
    let _time: string = getAppointmentTime(stop);
    _time = (_time || "")
      .split("AM")
      .join("am")
      .split("PM")
      .join("pm")
      .replace(/Z/g, "")
      .replace(/z/g, "");
    return _time;
  }
  let _newAptTime: string = getTime(
    stop.appointmentFrom || "",
    stop.appointmentTo || ""
  );
  _newAptTime = (_newAptTime || "")
    .split("AM")
    .join("am")
    .split("PM")
    .join("pm")
    .replace(/Z/g, "")
    .replace(/z/g, "");
  return _newAptTime;
};

export const isWatched = (watchedLoads: Array<[]>, loadId: String) => {
  let isWatched: boolean = false;
  watchedLoads &&
    watchedLoads.forEach((load: any) => {
      if (load.loadId == loadId) isWatched =  true;
    });
  return isWatched;
};
export const FireBaseLogEvent = (
  eventName: string,
  screenName: string,
  loadId?: string,
  carrierId?: string,
  lead?: string,
  rank?: any,
  resultId?: any
) => {
  let _rank = {};
  if (rank !== undefined || null  && resultId !== undefined || null) _rank = { rank, resultId };
  logEvent(eventName, {
    screen: screenName,
    loadId: loadId,
    carrierId: carrierId,
    lead: lead,
    ..._rank,
  });
};
export const LPEFeedBackLogEvent = (
  eventName: string,
  screenName: string,
  loadId?: string,
  lead?: string,
  rank?: string,
  resultId?: string
) => {
  let _rank = {};
  if (rank !== undefined || null  && resultId !== undefined || null) _rank = { rank, resultId };
  LPEFeedbackWrapper.log(eventName, {
    screen: screenName,
    loadId: [loadId],
    lead: lead,
    ..._rank,
  });
};